export default "/shDAI.e47656726f9209a0d20885622d077b7e.svg";